export default {
  updateNotificationsCount({ commit, getters }, newNotificationsOnly) {
    const onlyNewCountNotificationsTotal = newNotificationsOnly.all.total

    const newNotificationBellAmount =
      getters.getNotificationBellAmount + onlyNewCountNotificationsTotal

    const newLastTotalNotificationCount =
      getters.getLastTotalNotificationCount + onlyNewCountNotificationsTotal

    const newCurrentTotalNotificationCount =
      getters.getCurrentTotalNotificationCount + onlyNewCountNotificationsTotal

    commit("setNotificationBellAmount", newNotificationBellAmount)
    commit("setLastTotalNotificationCount", newLastTotalNotificationCount)
    commit("setCurrentTotalNotificationCount", newCurrentTotalNotificationCount)
  }
}
